import React from 'react';


export function useFirstRef<T>(initialValue?: T) {
  const indexRef = React.useRef(0);
  const [ ref, _setRef ] = React.useState<T | null | undefined>(initialValue ?? null);

  const setRef = React.useCallback((element?: T | null) => {
    if (element) {
      indexRef.current += 1;
    } else {
      indexRef.current -= 1;
    }

    if (indexRef.current === 1) {
      _setRef(element);
    }
    if (!indexRef.current) {
      _setRef(element);
    }
  }, [ _setRef ]);

  return [ ref, setRef ] as const;
}
